export default __webpack_public_path__ + "static/media/defaultuser.24d1485b.svg";